import getIFrameElementById from '../../getIFrameElementById';
import { ZendeskCustomScript, ZendeskWidgetModules } from '../../../types/zendesk.d';
import { zendeskWidgetConfig } from './zendeskWidgetConfig';

const addEventListenerToWidgetModule = (
  type: string,
  callback: () => void,
  module: ZendeskWidgetModules
): void => {
  const iframe = getIFrameElementById(module);

  if (
    iframe?.contentDocument != null &&
    typeof type === 'string' &&
    callback != null &&
    typeof callback === 'function'
  ) {
    if (type === 'click') {
      iframe.contentDocument.onclick = callback;
    }
  }
};

const addZendeskCustomScriptsToWidgetModule = (
  scripts: ZendeskCustomScript[],
  module: ZendeskWidgetModules
): void => {
  if (scripts != null && scripts.length && module != null) {
    const iframe = getIFrameElementById(module);

    if (iframe != null && iframe.contentWindow != null) {
      scripts.forEach(script => {
        if (script != null) {
          const scriptEl = document.createElement('script');
          scriptEl.src = script.path;
          scriptEl.id = script.id;
          scriptEl.type = 'module';

          iframe.contentWindow?.document.head.append(scriptEl);
        }
      });
    }
  }
};

const triggerEventForWidgetModule = (type: string, module: ZendeskWidgetModules): void => {
  const iframe = getIFrameElementById(module);

  if (iframe?.contentWindow != null && typeof type === 'string') {
    iframe.contentWindow.dispatchEvent(new Event(type));
  }
};

/** launcher events */

export const onZendeskLauncherClick = (callback: () => void) => {
  addEventListenerToWidgetModule('click', callback, ZendeskWidgetModules.Launcher);
};

/** widget events */

export const onZendeskWidgetClick = (callback: () => void) => {
  addEventListenerToWidgetModule('click', callback, ZendeskWidgetModules.Widget);
};

export const triggerLoadForZendeskWidget = (): void => {
  triggerEventForWidgetModule('load', ZendeskWidgetModules.Widget);
};

/** widget scripts */

export const scriptZendeskWidget = (): void => {
  addZendeskCustomScriptsToWidgetModule(
    [zendeskWidgetConfig.scripts.widget],
    ZendeskWidgetModules.Widget
  );
};
